/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors, devices } from '../../config/theme'

const style = {}

style.base = {}

style.base[devices.mobile] = {
  '& .footnote': {
    width: '100%'
  },
  '& .twoButtons': {
    zIndex: '12525242425',
    '& button': {
      width: '50% !important',
      zIndex: '12525242425'
    },
    '& button:nth-child(2)': {
      borderLeft: `solid 2px ${colors.white} !important`
    }
  }
}

export default style
